import { FC, useEffect,Dispatch } from 'react';
import NumberFormat from 'react-number-format';
import { Setting } from '../../App';
import classes from '../../asset/css/subscription-detail/product-item-paused.module.css';
import { useSubscriptionLine } from '../../hooks/use-subscription-line';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../../types/view/recommend-product-info-view-type';
import { SummaryViewType } from '../../types/view/summary-view-type';

export const ProductItemPaused: FC<{
  productItem: ProductInfoViewType;
  loading: boolean;
  setting: Setting;
  addProductSuccess: (showModal: boolean, status?: string) => void;
  failed: (message: string) => void;
  setSubscriptionContractId: Dispatch<string>;
  setRegisteredProducts: Dispatch<ProductInfoViewType[]>;
  setPausedProducts: Dispatch<ProductInfoViewType[]>;
  setRecommendProducts: Dispatch<RecommendProductInfoViewType[]>;
}> = ({
  productItem,
  loading,
  setting,
  addProductSuccess,
  failed,
  setSubscriptionContractId,
  setRegisteredProducts,
  setPausedProducts,
  setRecommendProducts,
}) => {
  const priceBlock = (
    <span className={classes.pausedItem_info_content_priceBlock_current}>
      <small>割引価格</small> ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
    </span>
  );
  // productItem.originalPrice === productItem.price ? (
  //   <>
  //     <span className={classes.pausedItem_info_content_priceBlock_current}>
  //       ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
  //     </span>
  //   </>
  // ) : (
  //   <>
  //     <span className={classes.pausedItem_info_content_priceBlock_original}>
  //       ￥<NumberFormat displayType="text" value={productItem.originalPrice} thousandSeparator={true} />
  //     </span>
  //     <span className={classes.pausedItem_info_content_priceBlock_arrow}>→</span>
  //     <span className={classes.pausedItem_info_content_priceBlock_current}>
  //       ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
  //     </span>
  //   </>
  // );

  const handleAddToBox = () => {
    window.parent.postMessage({ 
      action: 'clickAddToBox',
      variantId: productItem.variantId,
      planId: productItem.planId
    }, '*');
    console.log( 'emit clickAddToBox', productItem.variantId )
  };

  return (
    <li className={classes.pausedItem}>
      <div className={classes.pausedItem_container}>
        <a href={productItem.url} target="_blank" className={classes.pausedItem_thumbnail}>
          <div
            style={productItem.image ? { backgroundImage: `url('${productItem.image}')` } : {}}
            className={classes.pausedItem_thumbnail_img}
          />
        </a>

        <div className={classes.pausedItem_info}>
          {/* 商品名・価格 */}
          <div className={classes.pausedItem_info_content}>
            {/* 商品名 */}
            <h4 className={classes.pausedItem_info_content_title}>{productItem.productTitle}</h4>
            {/* 価格 */}
            <div className={classes.pausedItem_info_content_priceBlock}>{priceBlock}</div>
          </div>

          {/* アクションボタン */}
          <div className={classes.pausedItem_info_actions}>
            <button className={classes.pausedItem_info_actions_addBtn} disabled={loading} onClick={handleAddToBox}>
              BOXに追加
            </button>
          </div>
        </div>
      </div>
    </li>
  );
};
